import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source"];

  copy(event) {
    const button = event.target;
    if (this.hasSourceTarget) {
      navigator.clipboard.writeText(this.sourceTarget.value);
      if (button) {
        let dataset = button.dataset;
        if (dataset.clipboardTransform) {
          const others = document.querySelectorAll('.copied');
          for (let i = 0; i < others.length; i++) {
              others[i].innerHTML = "Kopiera biljettkod";
              others[i].classList.remove("flex");
              others[i].classList.remove("flex-row");
              others[i].classList.remove("flex-nowrap");
              others[i].classList.remove("gap-2.5");
              others[i].classList.remove("place-content-center");
              others[i].classList.remove("copied");
          }
          button.innerHTML = `<svg width="16" height="12" class="self-center" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.43455 11.7314L0.234549 6.53138C-0.0778574 6.21897 -0.0778574 5.71244 0.234549 5.4L1.36589 4.26863C1.6783 3.95619 2.18486 3.95619 2.49727 4.26863L6.00024 7.77156L13.5032 0.268626C13.8156 -0.0437807 14.3222 -0.0437807 14.6346 0.268626L15.7659 1.4C16.0783 1.71241 16.0783 2.21894 15.7659 2.53138L6.56592 11.7314C6.25349 12.0438 5.74695 12.0438 5.43455 11.7314Z" fill="#005293"/></svg><span class="self-center">Kopierad</span>`;
          button.classList.add("flex");
          button.classList.add("flex-row");
          button.classList.add("flex-nowrap");
          button.classList.add("gap-2.5");
          button.classList.add("place-content-center");
          button.classList.add("copied");
        }
      }
    }
  }
}